import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";

export default function ArticleCard({ article, variant = "default" }) {
  if (variant === "wide") {
    return (
      <Link
        to={`/guides/${article.slug}`}
        data-testid={`article-card-${article.slug}`}
        className="group grid md:grid-cols-5 gap-6 md:gap-10 editorial-card p-5 md:p-8"
      >
        <div className="md:col-span-2 aspect-[4/3] overflow-hidden bg-stone">
          <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-[1.04]" loading="lazy" />
        </div>
        <div className="md:col-span-3 flex flex-col justify-center">
          <div className="overline text-terracotta">{article.category}</div>
          <h3 className="mt-3 font-serif text-3xl md:text-4xl leading-[1.05] text-charcoal group-hover:text-terracotta transition-colors">
            {article.title}
          </h3>
          <p className="mt-4 text-charcoal/70 leading-relaxed">{article.excerpt}</p>
          <div className="mt-5 flex items-center gap-4 text-xs text-charcoal/60">
            <span>{article.author}</span>
            <span className="flex items-center gap-1"><Clock size={12} /> {article.read_minutes} min read</span>
          </div>
        </div>
      </Link>
    );
  }
  return (
    <Link
      to={`/guides/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group editorial-card overflow-hidden flex flex-col"
    >
      <div className="aspect-[4/3] overflow-hidden bg-stone">
        <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-[1.05]" loading="lazy" />
      </div>
      <div className="p-6 flex-1 flex flex-col">
        <div className="overline text-terracotta">{article.category}</div>
        <h3 className="mt-2 font-serif text-2xl leading-tight text-charcoal group-hover:text-terracotta transition-colors">
          {article.title}
        </h3>
        <p className="mt-3 text-sm text-charcoal/70 line-clamp-2">{article.excerpt}</p>
        <div className="mt-auto pt-4 flex items-center justify-between text-xs text-charcoal/60">
          <span className="flex items-center gap-1"><Clock size={12} /> {article.read_minutes} min</span>
          <ArrowRight size={14} className="text-charcoal/40 group-hover:text-terracotta group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
}
